const API_BASE =
  (import.meta.env.VITE_API_BASE as string | undefined) ?? '/api'

export interface Scan {
  id: string
  status: 'pending' | 'processing' | 'completed' | 'failed'
  splatUrl?: string
  meshUrl?: string
  thumbnailUrl?: string
  error?: string
  createdAt?: string
}

export async function uploadImage(file: File): Promise<{ id: string }> {
  const fd = new FormData()
  fd.append('image', file)
  const res = await fetch(`${API_BASE}/scan`, {
    method: 'POST',
    body: fd,
  })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(text || `Upload failed (${res.status})`)
  }
  return res.json()
}

export async function getScan(id: string): Promise<Scan> {
  const res = await fetch(`${API_BASE}/scan/${id}`)
  if (!res.ok) throw new Error(`Scan ${id} not found`)
  return res.json()
}
